import { GridHeaderWithTooltipComponent } from './data-widgets/grid-header-with-tooltip.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { RatingBarComponent } from './data-widgets/rating-bar.component';
import { SellerNameComponent } from './data-widgets/seller-name.component';
import { ReportConfig } from './REPORT_CONFIG';

export const REPORT_CONFIG_SELLER_COPPA_INDEX: ReportConfig = {
  key: 'seller-childrens-privacy',
  heading: "Children's Privacy Index",
  title: 'Market Share',
  formTitle: 'Children`s Privacy Index',
  pageTitle:
    "Children's Privacy for SSP’s, a Pixalate Rankings index: for {type}",
  pageMeta:
    "Children's Privacy measures estimated ercentage of a Seller’s ad impressions within likely child-directed (including mixed audience) {type} as compared to their peers.",
  reportId: 'sellerCoppaIndex',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 5,
  sortable: true,
  mainFilterItems: [
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Seller',
      key: 'sellerName',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      groups: ['app'],
      hoverKey: '',
      template: null,
      widgetComponent: SellerNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Child Audience Risk',
      key: 'childDirectedGrade',
      sort: 'sort-asc',
      sortDefault: false,
      sortColumnKey: 'rank',
      addSortColumnKeys: ['sellerSort'],
      hoverKey: '',
      template: null,
      widgetComponent: RatingBarComponent,
      hidden: false,
      lockIfAnonymous: true,
      lockIfFreemium: true,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: 'Child Audience Risk is a comparative measure of the percentage of a Seller’s ad impressions within likely child-directed (including mixed audience) apps as compared to their peers. It is sourced from 3rd-party data, and is NOT a factor in any other Pixalate Seller Trust Index scores',
        ctv: null,
        domain: null
      }
    },
    {
      label: 'Spacer',
      key: 'spacer',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      groups: ['app'],
      hoverKey: '',
      template: null,
      widgetComponent: null,
      hidden: false,
      format: '50%',
      headerWidgetComponent: GridHeaderComponent
    }
  ]
};
